<template>
  <div class="index-container">
    <div class="index-header" @click="onLogin">
      <div class="header">
        <span class="header-text">立即登录体验</span>
      </div>
    </div>
    <img
      src="../../assets/index.png?v=1"
      class="img"
      @click="onLogin"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    onLogin() {
      this.$router.push("/login");
    },
  },
};
</script>
<style scoped>
.index-container {
  width: 100%;
}
.index-container .img {
  width: 100%;
  margin: 0 auto;
}
.index-container .index-header{
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #FD6E28;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
}
.index-container .index-header .header{
  width: 1195px;
  text-align: right;
  margin: 0 auto;
}
.index-container .header-text{
  margin-right: 20px;
}
</style>
